import { gql } from '@apollo/client';

export const LeadListsRemoveUnpostedLeadsUpdateMutation = gql`
  mutation LeadListsRemoveUnpostedLeadsUpdate($input: LeadListsRemoveUnpostedLeadsUpdateInput!) {
    leadListsRemoveUnpostedLeadsUpdate(leadListsRemoveUnpostedLeadsUpdateData: $input) {
      message
    }
  }
`;
